import clsx from 'clsx';
import { StepCompleteIcon } from '../icons';

export const PaywallStepLine = () => <div className="h-px w-12 bg-[#CACACA]" />;

export const PaywallStep = ({
  state,
  label,
  index,
}: {
  state: 'complete' | 'active' | 'inactive';
  label: string;
  index?: number;
}) => (
  <div className="flex items-center gap-2">
    {state === 'complete' ? (
      <StepCompleteIcon className="h-[30px] w-[30px]" />
    ) : (
      <span
        className={clsx(
          'flex h-[30px] w-[30px] items-center justify-center rounded-full text-[15px]',
          state === 'active'
            ? 'bg-primary-blue text-white'
            : 'border border-[#D3E6F4] bg-[#F1F9FF] text-[#6D6D6D]'
        )}
      >
        {index}
      </span>
    )}
    <span className="text-[#6D6D6D]">{label}</span>
  </div>
);
